import { render, staticRenderFns } from "./materialBox.vue?vue&type=template&id=6faec5cc&scoped=true&"
import script from "./materialBox.vue?vue&type=script&lang=js&"
export * from "./materialBox.vue?vue&type=script&lang=js&"
import style0 from "./materialBox.vue?vue&type=style&index=0&id=6faec5cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faec5cc",
  null
  
)

export default component.exports